import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class IndicatorsApi {

  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source()

    return Request.get('/indicators', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async getConfig() {
    return Request.get('/indicators/config');
  }

  static async fetchOne(id) {
    return Request.get(`/indicators/${id}`);
  }

  static async update(data) {
    return Request.put(`/c/indicators/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/indicators/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/indicators`, data);
  }
}
